import React, { createContext, useContext, useState, useCallback } from "react";

const ModalContext = createContext();

export const NotificationModalProvider = ({ children }) => {
  const [modalProps, setModalProps] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const showNotificationModal = useCallback((props) => {
    setModalProps(props);
    setIsVisible(true);
  }, []);

  const hideNotificationModal = useCallback(() => {
    setIsVisible(false);
    setModalProps(null);
  }, []);

  return (
    <ModalContext.Provider
      value={{
        showNotificationModal,
        hideNotificationModal,
        modalProps,
        isVisible,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useNotificationModal = () => {
  const context = useContext(ModalContext);

  if (!context) {
    throw new Error("useNotificationModal");
  }

  return context;
};
